import { Alert, Button, Form, Input } from "antd";
import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ApiError } from "../api/client.js";
import { useAuth } from "../auth/AuthContext.js";

export function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (user) {
    return <Navigate to="/properties" replace />;
  }

  const from = (location.state as { from?: string } | null)?.from ?? "/properties";

  const onFinish = async (values: { username: string; password: string }) => {
    setSubmitting(true);
    setError(null);
    try {
      await login(values.username, values.password);
      navigate(from, { replace: true });
    } catch (caught) {
      setError(
        caught instanceof ApiError && caught.status === 401
          ? "invalid credentials"
          : "login failed — is the dashboard server running?",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-box">
        <div className="login-wordmark">
          adigium<span className="slash">/</span>conf
        </div>
        <div className="login-sub">configuration console</div>
        <div className="login-card">
          {error && <Alert type="error" message={error} style={{ marginBottom: 14 }} showIcon />}
          <Form layout="vertical" onFinish={(values) => void onFinish(values)} requiredMark={false}>
            <Form.Item
              label={<span className="microlabel">operator</span>}
              name="username"
              rules={[{ required: true, message: "username required" }]}
            >
              <Input autoFocus autoComplete="username" />
            </Form.Item>
            <Form.Item
              label={<span className="microlabel">passphrase</span>}
              name="password"
              rules={[{ required: true, message: "password required" }]}
            >
              <Input.Password autoComplete="current-password" />
            </Form.Item>
            <Button type="primary" htmlType="submit" block loading={submitting}>
              Enter console
            </Button>
          </Form>
        </div>
        <div className="login-foot microlabel">internal tool — all changes are audited</div>
      </div>
    </div>
  );
}
